import styled from 'styled-components';

const label = styled.span`
  font-weight: 600;
`;

const value = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const title = styled.h5`
  font-weight: 600;
  margin-top: 1rem;
`;

const Info = {
  Label: label,
  Value: value,
  Title: title,
};

export default Info;
